// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import state from './state'
import Multiselect from 'vue-multiselect'
import Requirement from './components/requirement.vue'
import 'babel-polyfill'
import {http, axios} from './http'
import VueAnalytics from 'vue-analytics'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VTooltip from 'v-tooltip'
import VModal from 'vue-js-modal'

// Import styles
require('./assets/styles/application.scss')
require('swiper/dist/css/swiper.css')

Vue.config.productionTip = false

// Make Axios global
Vue.prototype.$axios = axios

// AXIOS with base s3 url set
Vue.prototype.$http = http

// Global components
Vue.component('multiselect', Multiselect)
Vue.component('requirement', Requirement)

// Directives
Vue.directive('focus', {
  inserted(el) {
    el.focus()
  }
})

// Setup vue modal
Vue.use(VModal)

// Setup Vuex store
Vue.use(Vuex)
const store = new Vuex.Store(state)

// Setup VueAwesomeSwiper store
Vue.use(VueAwesomeSwiper)

// setup v-tooltip
Vue.use(VTooltip)

// Setup Vue Analytics
if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    set: [
      { field: 'dimension1', value: process.env.UNIVERSITY_ID },
      { field: 'dimension2', value: getPeriod() }
    ]
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

function getPeriod() {
  const date = new Date()
  const year = date.getFullYear()

  switch (date.getMonth()) {
  case 11:
  case 0:
    return `Winter ${year}`
  case 1:
  case 2:
  case 3:
  case 4:
    return `Spring ${year}`
  case 5:
  case 6:
    return `Summer ${year}`
  case 7:
  case 8:
  case 9:
  case 10:
    return `Fall ${year}`
  }
}



// WEBPACK FOOTER //
// ./src/main.js